
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g72QsaE2E4uGuquvSgYHK7xP2X2bAwOHA6PCUpBsZLagMeta } from "/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexYGu7NY8MPEaW0lDTkkmtKl_ejU6vGDuS0QEHlG9DPakMeta } from "/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchQGrmArgBn6s_45VGBNLawqF62FAt582fEv8yKWb0qoMBwMeta } from "/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexB9RGJrqJ2A_Xn1LrN6Nmci_6BETK3ZdH0qdZrpKOM4QMeta } from "/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_936Ef9gsXP5e3M6RKmX0idrCaE0bp5Z2_2yD_45q9tgKgacMeta } from "/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexM1efu0pK20FdegJiQtT7YlR7jyHk77nC8_45seveZL1TAMeta } from "/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93ikHoePEq0qKNzSgjAii8zlDZu1zsz8N_v_jaB5uq37UMeta } from "/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexhgWLCF5sGpDiEvqi_IqO8P4KbH0KFomD38s60NuFAgMMeta } from "/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93bGd6ybE7ngdOoAgiWzjYtmTD_45DqwR5IT1Nci_xjkSgIMeta } from "/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexJUW_45MDzXPEeB_1rX9qLPbW1U5gSkx6cra5fBxABD8E8Meta } from "/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexrFqVPjzCkgNdAECY5zxyXaXftgMRZRSFjJNwE_HL7WUMeta } from "/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexM1efu0pK20FdegJiQtT7YlR7jyHk77nC8_45seveZL1TAMeta || {},
    component: () => import("/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexhgWLCF5sGpDiEvqi_IqO8P4KbH0KFomD38s60NuFAgMMeta || {},
    component: () => import("/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexJUW_45MDzXPEeB_1rX9qLPbW1U5gSkx6cra5fBxABD8E8Meta || {},
    component: () => import("/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexrFqVPjzCkgNdAECY5zxyXaXftgMRZRSFjJNwE_HL7WUMeta || {},
    component: () => import("/codebuild/output/src2175340700/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]